import * as React from 'react';
import { AttachmentInfo } from '../../../types';
import { getFileIcon } from '../../../utils/fileIcons';
import './AttachmentsList.css';

export interface AttachmentsListProps {
  attachments: AttachmentInfo[];
  isProcessing: boolean;
  onToggle: (id: string) => void;
  onToggleAll: () => void;
}

const AttachmentsList: React.FC<AttachmentsListProps> = ({
  attachments,
  isProcessing,
  onToggle,
  onToggleAll,
}) => {
  const allSelected = attachments.every(att => att.selected);
  const someSelected = attachments.some(att => att.selected);

  return (
    <div className="form-section">
      <div className="attachments-header">
        <label className="form-label">Bijlagen selecteren</label>
        <span className="attachments-count">{attachments.length} files</span>
      </div>

      <label className="select-all-wrapper">
        <input
          type="checkbox"
          checked={allSelected}
          ref={(el) => {
            if (el) {
              el.indeterminate = someSelected && !allSelected;
            }
          }}
          onChange={onToggleAll}
          disabled={isProcessing}
        />
        <span className="select-all-label">
          Alle bijlagen selecteren ({attachments.length})
        </span>
      </label>

      <div className="attachments-card">
        {attachments.map((att) => {
          const fileIconInfo = getFileIcon(att.name);
          return (
            <div key={att.id} className="attachment-item" onClick={() => !isProcessing && onToggle(att.id)}>
              <input
                type="checkbox"
                className="attachment-checkbox"
                checked={att.selected}
                onChange={() => onToggle(att.id)}
                disabled={isProcessing}
                onClick={(e) => e.stopPropagation()}
              />
              <div className={`attachment-icon ${fileIconInfo.className}`}>
                <span className="material-icons-round">{fileIconInfo.icon}</span>
              </div>
              <div className="attachment-info">
                <p className="attachment-name">{att.name}</p>
                <p className="attachment-size">{(att.size / 1024).toFixed(1)} KB</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AttachmentsList;
